<div
  class="media-container"
  [class.media]="media.mediaType === 1"
  [class.dynamic]="media.mediaType === 2"
  [class.link]="media.mediaType === 3"
  [class.on-drag]="onDrag"
  [style.background-image]="
    media.mediaType === 1 && mediaInfo
      ? 'url(' + mediaInfo.contentSnapshotUrl + ')'
      : undefined
  "
  (dragenter)="onDragEnter()"
  (dragleave)="onDragLeave()"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
>
  <ng-template [ngIf]="media.mediaType === 0">
    <div inlineSVG="/assets/icons/upload-icon.svg" class="plus-sign"></div>
    <div class="inner-text">Add Media</div>
  </ng-template>

  <ng-template [ngIf]="media.mediaType === 2">
    <div inlineSVG="/assets/icons/rule-icon.svg"></div>
    <div>
      <span>{{ media.dynamic }}</span>
    </div>
  </ng-template>

  <ng-template [ngIf]="media.mediaType === 3">
    <img [src]="media.link" [alt]="media.link || ''" />
  </ng-template>

  <div class="hover-menu">
    <div
      class="icon first"
      [inlineSVG]="dynamicIcon"
      (click)="onDynamicClick()"
    ></div>
    <div
      class="icon second"
      [inlineSVG]="linkIcon"
      (click)="onLinkClick()"
    ></div>
  </div>
  <div
    class="x-sign"
    *ngIf="media && media.mediaType !== 0"
    inlineSVG="/assets/icons/x-close-pop.svg"
    (click)="removeMedia()"
  ></div>
  <div *ngIf="isVideo()" class="description-icon video"></div>
  <div
    *ngIf="isImage()"
    class="description-icon"
    inlineSVG="/assets/icons/upload-packshot.svg"
  ></div>
</div>
<div class="media-label">{{ media.label }}</div>
